import type { HistoryDateFilter, Language } from '@/shared/types';
import {
  FILE_TYPES,
  type FileType,
  type GenerateStatementFormValues,
} from '../model';

const getDefaultFormValues = (
  language: Language,
  dateFilter?: HistoryDateFilter,
  dateFrom?: Date,
  dateTo?: Date,
  fileType?: FileType,
  formValues?: GenerateStatementFormValues
): GenerateStatementFormValues => {
  const baseValues: GenerateStatementFormValues = {
    lang: formValues?.lang || language,
    datefilter: 'last24h',
    datefrom: undefined,
    dateto: undefined,
    fileType: fileType ?? FILE_TYPES[0],
  };

  if (dateFrom && dateTo) {
    return {
      ...formValues,
      ...baseValues,
      datefilter: 'custom',
      datefrom: dateFrom,
      dateto: dateTo,
    };
  }

  if (dateFilter) {
    return {
      ...formValues,
      ...baseValues,
      datefilter: dateFilter,
      datefrom: dateFrom,
      dateto: dateTo,
    };
  }

  if (!formValues) {
    return baseValues;
  }

  return formValues;
};

export { getDefaultFormValues };
